// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xirw","left":"styles_left__2zEeV"};